module.exports = __webpack_public_path__ + "img/fission-banner.a55be248.png";